import { createSelector } from '@ngrx/store'
import { RootState } from '../../root.model'
import { SessionCacheRedux } from './session-cache.reducer'

const sessionCacheState = (state: RootState) => state.helios.sessionCache

export const selectAllSessionCacheStatus = createSelector(
  sessionCacheState,
  (state: SessionCacheRedux) => state.status,
)

export const selectCwTransactionsSessionCacheStatus = createSelector(
  sessionCacheState,
  (state: SessionCacheRedux) => state.status.CwTransactions,
)

export const selectExtTransactionsSessionCacheStatus = createSelector(
  sessionCacheState,
  (state: SessionCacheRedux) => state.status.ExtTransactions,
)

export const selectPositionsSessionCacheStatus = createSelector(
  sessionCacheState,
  (state: SessionCacheRedux) => state.status.Positions,
)

// Flex (2.0) slots. One selector per slot, mirroring the three legacy selectors above, so a 2.0
// panel subscribes to exactly the cache its current grid source is fed by.

export const selectFlexPositionsSessionCacheStatus = createSelector(
  sessionCacheState,
  (state: SessionCacheRedux) => state.status.FlexPositions,
)

export const selectFlexExternalPositionsSessionCacheStatus = createSelector(
  sessionCacheState,
  (state: SessionCacheRedux) => state.status.FlexExternalPositions,
)

export const selectFlexTransactionsSessionCacheStatus = createSelector(
  sessionCacheState,
  (state: SessionCacheRedux) => state.status.FlexTransactions,
)

export const selectFlexExternalTransactionsSessionCacheStatus = createSelector(
  sessionCacheState,
  (state: SessionCacheRedux) => state.status.FlexExternalTransactions,
)
